// extracted by mini-css-extract-plugin
module.exports = {"root":"_05b8d2","icon":"_b6ae77","button":"_4a405f"};